module.exports = __webpack_public_path__ + "static/media/12@1920w.ead4fe1a.jpg";